"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDUCER_UPDATE_USER_ZONE = exports.REDUCER_UPDATE_USER_ADDRESS = exports.REDUCER_REMOVE_USER_ADDRESS = exports.REDUCER_GET_ZONES_FOR_LAT_LONG = exports.REDUCER_GET_USER_ADDRESS = exports.REDUCER_DEFAULT_USER_ADDRESS = exports.REDUCER_ADD_USER_ADDRESS = void 0;
const REDUCER_GET_USER_ADDRESS = exports.REDUCER_GET_USER_ADDRESS = 'getUserAddress';
const REDUCER_ADD_USER_ADDRESS = exports.REDUCER_ADD_USER_ADDRESS = 'addUserAddress';
const REDUCER_REMOVE_USER_ADDRESS = exports.REDUCER_REMOVE_USER_ADDRESS = 'removeUserAddress';
const REDUCER_DEFAULT_USER_ADDRESS = exports.REDUCER_DEFAULT_USER_ADDRESS = 'defaultUserAddress';
const REDUCER_UPDATE_USER_ADDRESS = exports.REDUCER_UPDATE_USER_ADDRESS = 'addUserAddress';
const REDUCER_UPDATE_USER_ZONE = exports.REDUCER_UPDATE_USER_ZONE = 'updateUserZone';
const REDUCER_GET_ZONES_FOR_LAT_LONG = exports.REDUCER_GET_ZONES_FOR_LAT_LONG = 'getZonesForLatLong';